// Colour names on Fashion variants are free text from the item master ("Navy",
// "Off White", "Bottle Green"). Swatches need a paintable colour, so this maps
// the names stores actually use to a hex value. Unknown names return null and
// the swatch falls back to a neutral outlined dot instead of an invalid CSS
// value that the browser would silently drop.
const NAMED = {
  black: "#1F1F1F", jetblack: "#111111", charcoal: "#3A3D42", grey: "#9A9EA5", gray: "#9A9EA5", lightgrey: "#C9CCD1", darkgrey: "#5B5F66",
  greymelange: "#A9ACB1", ash: "#B2B4B6", silver: "#C0C3C7", white: "#F7F7F5", offwhite: "#F2EFE6", ivory: "#F4EFDF", cream: "#EFE6CF",
  ecru: "#E3D7BD", beige: "#D9C7A7", sand: "#D6C2A0", stone: "#BDB4A4", khaki: "#B7A67E", camel: "#B8875A", tan: "#C19A6B",
  brown: "#6E4A32", chocolate: "#4E3226", coffee: "#5A3E2B", rust: "#B5563A", copper: "#B06A3B", mustard: "#D4A637", yellow: "#EBC944",
  lemon: "#F1E27A", gold: "#C9A646", orange: "#E07B39", peach: "#F2BFA0", coral: "#E9765E", red: "#C23B32", maroon: "#6E1F2A",
  wine: "#6A1E33", burgundy: "#6B1F2E", pink: "#E7A3B5", blush: "#EBC1C3", rose: "#D9858F", fuchsia: "#C2357D", magenta: "#B5307A",
  lavender: "#B9A9D6", lilac: "#C3A6CF", purple: "#6C3D8F", mauve: "#A57F98", plum: "#6A3A5C", navy: "#24324A", navyblue: "#24324A",
  blue: "#3466A8", royalblue: "#2F55B5", skyblue: "#9DB8D9", sky: "#9DB8D9", lightblue: "#A9C6E3", powderblue: "#B9CFE4", indigo: "#2E3A66",
  denim: "#3F5878", teal: "#2A7B7B", turquoise: "#3AAFA9", aqua: "#7FCFCB", mint: "#A9DCC0", green: "#3D8550", olive: "#6E7041",
  sage: "#9AAE8F", bottlegreen: "#1F4D36", emerald: "#1F7A55", forestgreen: "#2D5A3A", lime: "#B5D365", multi: null, multicolour: null,
};

const key = (name) => String(name || "").toLowerCase().replace(/[^a-z]/g, "");

export function colourHex(name) {
  if (name == null) return null;
  const raw = String(name).trim();
  if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(raw)) return raw.toUpperCase();
  const k = key(raw);
  if (!k) return null;
  if (NAMED[k] !== undefined) return NAMED[k];
  // "Dark Navy", "Navy Check": fall back to the last word that names a colour
  const words = raw.toLowerCase().split(/[^a-z]+/).filter(Boolean);
  for (const w of [...words].reverse()) if (NAMED[w]) return NAMED[w];
  return null;
}

// Inline style for a swatch dot: the colour when known, otherwise nothing so the
// stylesheet's neutral outlined dot shows.
export function swatchStyle(name) {
  const hex = colourHex(name);
  return hex ? { background: hex } : undefined;
}
